import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { IMG, PIXEL_ID, CHECKOUT } from './components/data';
function loadMetaPixel() {
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  w.fbq('init', PIXEL_ID);
  w.fbq('track', 'PageView');
}
// Pasa las UTMs y el fbclid del anuncio al checkout de Impultienda
function passParamsToCheckout(e: MouseEvent) {
  const a = (e.target as HTMLElement)?.closest?.('a') as HTMLAnchorElement | null;
  if (!a || !a.href.startsWith(CHECKOUT)) return;
  const qs = window.location.search;
  if (qs && !a.href.includes('?')) a.href = CHECKOUT + qs;
}
export function App() {
  useEffect(() => {
    document.title = 'Agenda Activa · 36 sesiones listas para adultos mayores';
    const preload = document.createElement('link');
    preload.rel = 'preload';
    preload.as = 'image';
    preload.href = IMG.t2;
    document.head.appendChild(preload);
    ['https://connect.facebook.net', 'https://www.facebook.com'].forEach(origin => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      document.head.appendChild(link);
    });
    document.addEventListener('click', passParamsToCheckout, true);
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(loadMetaPixel, {
        timeout: 3500
      });
    } else {
      setTimeout(loadMetaPixel, 2000);
    }
    return () => document.removeEventListener('click', passParamsToCheckout, true);
  }, []);
  return <LandingPage data-id="element-0" data-mp="sudlygrs019b" />;
}